/**
 * Ryan O'Dowd
 * 2024-10-09
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({windowWidthRaw, windowHeight}) => {
  const maxHeight = windowHeight - (Platform.OS === 'web' ? (56 + 8) : 0); // @TODO: don't hardcode header height

  return {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
      width: windowWidthRaw,
      height: windowHeight,
      alignItems: 'center',
      justifyContent: 'center',
    },
    backgroundImageWrapper: {
      flex: 1,
      width: '100%',
      maxHeight,
    },
    rain: {
      width: windowWidthRaw,
      height: windowHeight,
      maxHeight,
    },
  };
};

export default getStyles;
